export default __webpack_public_path__ + "static/media/Fair-tr.839c7fec.png";